const tabButtonsContainer = document.querySelector(".tab-buttons");
const tabButtons = document.querySelectorAll(".tab-button");
const tabContents = document.querySelectorAll(".tab_content");

if (tabButtonsContainer && tabButtons.length === 1) {
  tabButtonsContainer.classList.add("hidden");
}

tabButtons.forEach((button) => {
  button.addEventListener("click", function () {
    // Remove active class from all buttons and contents
    tabButtons.forEach((btn) => btn.classList.remove("active"));
    tabContents.forEach((content) => content.classList.remove("active"));

    // Add active class to clicked button
    button.classList.add("active");

    // Show corresponding content
    const tabId = button.getAttribute("data-tab");
    const tabContent = document.getElementById(tabId);
    if (tabContent) {
      tabContent.classList.add("active");
    }
  });
});
